namespace $.$$ {
	
	$mol_style_define( $mol_form_draft, {
		
		width: '100%',
		
	} )
	
}
